module.exports = __webpack_public_path__ + "static/media/mahmoud.ae968419.jpeg";